"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterBedGroupState = void 0;
var SfilterKey_1 = require("@/pages/common/states/sfilter/SfilterKey");
exports.defaultSfilterBedGroupState = {
    key: SfilterKey_1.SfilterKey.BED,
    name: 'Beds',
    opened: false,
    selected: -1,
    options: [
        { name: 'Studio', beds: 0 },
        { name: '1+', beds: 1 },
        { name: '2+', beds: 2 },
        { name: '3+', beds: 3 },
        { name: '4+', beds: 4 },
        { name: '5+', beds: 5 },
    ],
};
